import { Component, OnInit, OnDestroy,ViewChild  } from '@angular/core';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { TipoServicioService } from '../../servicios/tiposervicio.service';
import { PersonaService } from '../../servicios/persona.service';
import { VehiculoService } from '../../servicios/vehiculo.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { EmpresaService } from '../../servicios/empresa.service';
import { BsModalComponent,BsModalService  } from 'ng2-bs3-modal';
import { setTimeout } from 'timers';
declare var jQuery: any;

@Component({
    selector: 'usuarios',
    templateUrl: 'usuarios.template.html'
})

export class UsuariosComponent implements OnInit{
    
    constructor(
        private modalservice: BsModalService,
        private personaService: PersonaService,
        private alertService: AlertService,
        private tipoServicioService: TipoServicioService,
        private vehiculoService: VehiculoService,
        private empresaService: EmpresaService,
        private router: Router,
        private route: ActivatedRoute,
    ) {

    }
    @ViewChild('modal')
    public modal: BsModalComponent;
    public sub:any;
    public filter = "";
    public usuario:any = {permisos:[]};
    public aux: any;
    public usuarios = [];
    public permisos = [];
    public permisosAdd = [];
    public permisosAux = [];
    public update = false;
    public mostrarSelect = false;
    public empresas = [];

    
    ngOnInit() {

        this.getUsuarios();
        this.getPermisos();
        this.getEmpresas();

    }

    onChange(){
        
        this.usuario.idEmpresa = null;

        if(this.usuario.rol == 2){
            this.mostrarSelect=true;
            this.permisosAux = [{id: 2, nombre: "Gestionar Vehiculos"},{id:3, nombre:"Gestionar Conductores"},{id:6, nombre:"Geolocalizacion"},{id:7, nombre:"Reportes"}];
        }else{
            this.mostrarSelect=true;
            this.permisosAux = this.permisos;
        }

    }

    files: FileList;
    getUsuarios() {
        loading_show();
        this.personaService.getAllByRol(1,(data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.usuarios = data.Content;
            }

        });
    }

    getPermisos() {
        loading_show();
        this.personaService.getPermisos((data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.permisos = data.Content;
            }

        });
    }

    getEmpresas() {
        loading_show();
        this.empresaService.getAll((data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.empresas = data.Content;
            }

        });
    }

    getFiles(event: any) {
        this.files = event.target.files;
        for (var i = 0, f; f = this.files[i]; i++) {
            if (!f.type.match('image.*')) {
                continue;
            }
            var reader = new FileReader();
            reader.onload = (function (theFile) {
                return function (e) {
                    document.getElementById("image").innerHTML = ['<img class="animated bounceIn" style="width:60%; margin-left:20%" src="', e.target.result, '" />'].join('');
                };
            })(f);
            reader.readAsDataURL(f);
        }
    }

    saveUsuario() {

        if (!this.usuario['estado']) {
            this.usuario['estado'] = 'ACTIVO';
        }

        if(!this.usuario['nombre'] || !this.usuario['apellidos'] || !this.usuario['cedula'] || !this.usuario['telefono']  || !this.usuario['email'] || !this.usuario['clave'] || !this.usuario['rol']){
            this.alertService.error("Debes Diligenciar todos los CAMPOS OBLIGATORIOS (*)");
            return;
        }

        var permisos=[];
        jQuery('input[name="PermisosAdd[]"]:checked').each(function(){
            permisos.push(parseInt(this.id));
        });

        var object = {
            'nombre': this.usuario['nombre'],
            'apellidos': this.usuario['apellidos'],
            'cedula': this.usuario['cedula'],
            'direccion':this.usuario['direccion'],
            'telefono':this.usuario['telefono'],
            'fecha_nacimiento':this.usuario['fecha_nacimiento'],
            'email':this.usuario['email'],
            'clave':this.usuario['clave'],
            'estado': this.usuario['estado'],
            'rol':this.usuario['rol'],
            'idEmpresa':this.usuario['idEmpresa'],
            'permisos':permisos,
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.personaService.save(object, (data: Result) => {
            loading_hide();

            if (data.isOk) {
                this.getUsuarios();
                this.usuario = {};
                this.alertService.success(data.Mensaje);
            }else{
                this.alertService.error(data.Mensaje);
            }
        });

    }

    showUsuario(user: any) {
        this.usuario = user;
        if(this.usuario.rol == 1){
            this.mostrarSelect = true;
            this.permisosAux = this.permisos;
        }else{
            this.mostrarSelect=true;
            this.permisosAux = [{id: 2, nombre: "Gestionar Vehiculos"},{id:3, nombre:"Gestionar Conductores"},{id:6, nombre:"Geolocalizacion"},{id:7, nombre:"Reportes"}];
        }

        setTimeout(()=>{
            console.log(this.permisosAux);
            jQuery(".ch").prop("checked", false);

            for (let i of this.usuario.permisos) {
                console.log(i);
                jQuery("#"+i).prop("checked", true);
            }
        },200);

        

        this.update = true;
        jQuery("#tipoUsuario").attr("disabled","disabled");
        jQuery("#clave").attr("disabled","disabled");
        jQuery("#t1").addClass("active");
        jQuery("#t2").removeClass("active");
        jQuery("#tab-1").addClass("active");
        jQuery("#tab-2").removeClass("active");
    }


    cancel() {
        this.usuario ={};
        this.update = false;
        this.mostrarSelect = false;
        jQuery("#clave").removeAttr("disabled");
        jQuery("#tipoUsuario").removeAttr("disabled");
        jQuery(".ch").prop("checked", true);
        document.getElementById("image").innerHTML = '<div class="row">' +
            '<div class="col-lg-12" style="text-align: center;">' +
            '<i class="fa fa-image ico-bg"></i>' +
            '</div>' +
            '</div>';
    }

    updateUsuario() {
        
        if (!this.usuario['estado']) {
            this.usuario['estado'] = 'ACTIVO';
        }

        if(!this.usuario['nombre'] || !this.usuario['apellidos'] || !this.usuario['cedula'] || !this.usuario['telefono']  || !this.usuario['email']){
            this.alertService.error("Debes Diligenciar todos los CAMPOS OBLIGATORIOS (*)");
            return;
        }

        var permisos=[];
        jQuery('input[name="PermisosAdd[]"]:checked').each(function(){
            permisos.push(parseInt(this.id));
        });


        var object = {
            'id': this.usuario['idPersona'],
            'nombre': this.usuario['nombre'],
            'apellidos': this.usuario['apellidos'],
            'cedula': this.usuario['cedula'],
            'direccion':this.usuario['direccion'],
            'telefono':this.usuario['telefono'],
            'fecha_nacimiento':this.usuario['fecha_nacimiento'],
            'email':this.usuario['email'],
            'estado': this.usuario['estado'],
            'idEmpresa': this.usuario['idEmpresa'],
            'rol':this.usuario['rol'],
            'placa': this.usuario['placa'],
            'permisos':permisos,
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.personaService.update(object, (data: Result) => {
            loading_hide();
            console.log(data)
            if (data.isOk) {
                this.update = false;
                this.getUsuarios();
                this.usuario = {};
                this.alertService.success(data.Mensaje);
                jQuery("#clave").removeAttr("disabled");
                jQuery("#tipoUsuario").removeAttr("disabled");
                jQuery(".ch").prop("checked", true);
                this.mostrarSelect = false;
            }else{
                this.alertService.error(data.Mensaje);
            }
        });
    }


    updateState(id: number, state: string) {
        loading_show();
        var object = {
            'id': id,
            'estado': state
        }

        this.personaService.updateState(object, (data: Result) => {
            loading_hide();
            if (data.isOk) {
                this.alertService.success("Estado actualizado");
                this.getUsuarios();
            }
        });
    }

    modalClave(usuario:any) {

        this.modal.open();
        this.usuario = usuario;

    }

    cambiarClave() {
        loading_show();
        var object = {
            'idUsuario': this.usuario.idUsuario,
            'clave': this.usuario.clave
        }

        this.personaService.cambiarClave(object, (data: Result) => {
            loading_hide();
            if (data.isOk) {
                this.alertService.success("Clave actualizada");
                this.getUsuarios();
                this.modal.close();
            }
        });
    }


    modalCancelar(){
        this.usuario = {};
        this.modal.close();
    }
}


// WEBPACK FOOTER //
// ./src/app/views/usuarios/usuarios.component.ts